/**
 * Мок журнала аудита: правдоподобная лента действий команды (свежие сверху)
 * + эмуляция cursor-пагинации (курсор — строковый offset), чтобы «Показать
 * ещё» вёл себя как с живым BE.
 */

import type {AuditEntry, AuditPage, GetAuditRequest} from './types';

const ago = (hours: number): string => new Date(Date.now() - hours * 3_600_000).toISOString();

const TEAM = '+996 700 123 456';

type Seed = [hoursAgo: number, action: string, entityType: string, payload: AuditEntry['payload']];

const SEEDS: Seed[] = [
  [1, 'tariff_clinic_update', 'tariff', {version: 8, overPriceTiyin: 90000}],
  [1.4, 'tariff_solo_update', 'tariff', {version: 5, priceTiyin: 150000}],
  [2, 'archive_client', 'client', {reason: 'Клиника закрылась, попросили остановить подписку'}],
  [3, 'update_client', 'client', {name: 'Дентал Плюс Про'}],
  [4, 'add_doctor', 'doctor', {fullName: 'Осмонова Динара'}],
  [5.5, 'change_admin_phone', 'client', {newPhone: '+996 700 555 010'}],
  [7, 'create_client', 'client', {type: 'clinic', seats: 5}],
  [9, 'reset_password', 'client', null],
  [26, 'update_doctor', 'doctor', {specialization: 'Ортодонт'}],
  [27, 'remove_doctor', 'doctor', {fullName: 'Тестова Врач'}],
  [29, 'tariff_solo_update', 'tariff', {version: 4, priceTiyin: 120000}],
  [31, 'update_client', 'client', {address: 'ул. Ленина 42, оф. 3'}],
  [50, 'create_client', 'client', {type: 'solo'}],
  [52, 'archive_client', 'client', {reason: null}],
  [55, 'update_client', 'client', {language: 'kg'}],
  [74, 'add_doctor', 'doctor', {fullName: 'Асанов Тилек'}],
  [76, 'change_admin_phone', 'client', {newPhone: '+996 555 118 902'}],
  [78, 'reset_password', 'client', null],
  [96, 'tariff_clinic_update', 'tariff', {version: 7}],
  [98, 'update_client', 'client', {notes: '…'}],
  [120, 'create_client', 'client', {type: 'clinic', seats: 3}],
  [122, 'update_doctor', 'doctor', {phone: '+996 707 210 556'}],
  [144, 'remove_doctor', 'doctor', {fullName: 'Иманова Асель'}],
  [146, 'update_client', 'client', {businessPhone: '+996 3722 5-11-90'}],
  [168, 'create_client', 'client', {type: 'solo'}],
];

export const MOCK_AUDIT: AuditEntry[] = SEEDS.map(([hours, action, entityType, payload], i) => ({
  id: `audit-${i + 1}`,
  actorLogin: TEAM,
  action,
  entityType,
  entityId: entityType === 'tariff' ? null : `e-${(i % 7) + 1}`,
  payload,
  createdAt: ago(hours),
}));

/** Страница мока: фильтр по from + slice по строковому курсору-offset. */
export const mockAuditPage = ({from, cursor, limit = 20}: GetAuditRequest): AuditPage => {
  const filtered = from === undefined ? MOCK_AUDIT : MOCK_AUDIT.filter((e) => e.createdAt >= from);
  const start = cursor === undefined ? 0 : Number(cursor) || 0;
  const items = filtered.slice(start, start + limit).map((e) => ({...e}));
  const nextCursor = start + limit < filtered.length ? String(start + limit) : null;
  return {items, nextCursor};
};
